module.exports = __webpack_public_path__ + "media/images/homes/retail2x-aca27eee53ab5aa20bcd56c427209d6f.png";